// extracted by mini-css-extract-plugin
export default {"rangeLabel":"inputSlider_rangeLabel__NmTNF","sliderTable":"inputSlider_sliderTable__3vwA1","slider":"inputSlider_slider__iMKXM"};